var map = {
	"./01.jpg": 6748,
	"./02.jpg": 3943,
	"./03.jpg": 6245,
	"./04.jpg": 611,
	"./desktop/01.jpg": 7523,
	"./desktop/02.jpg": 8279,
	"./desktop/03.jpg": 4876,
	"./desktop/04.jpg": 6806,
	"./kela-2.svg": 426,
	"./kela.svg": 514,
	"./left.svg": 7183,
	"./right.svg": 2084
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9675;